/**
 * (配車スケジュール 詳細) LINEコピー機能 Script関数ファイル
 */

/* Import Modules */
import $ from "jquery";
import toastr from "toastr";

/* Copy Script */
// [LINEコピー]ボタン 押下イベント
export const copyLineClipboard = (values: string) => {
    // Make Textarea Element.
    let $element = $("<textarea></textarea>");

    // Insert Copy Value
    $element.text(values);

    // Append Element.
    $(this).append($element);

    // Run Copy
    // document.execCommand('copy');
    navigator.clipboard.writeText($element.val()).then(
        // Show Toastr
        (success) => toastr.success("コピーしました"),
        (error) => toastr.error("予期せぬエラーが発生しました")
    );

    // Remove Element.
    $element.remove();
};

/**
 * グローバル関数を定義
 */
(window as any).copyLineClipboard = copyLineClipboard;
